import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex w-full flex-col items-center justify-center px-6 py-32 text-center md:py-48">
      <span className="font-label text-xs tracking-[0.4em] text-secondary-500">404 NOT FOUND</span>
      <h1 className="mt-6 font-display text-5xl font-light tracking-[0.08em] text-foreground-950 md:text-7xl">
        Page Not Found
      </h1>
      <p className="mt-8 max-w-md font-body text-sm leading-[2.1] text-foreground-600">
        お探しのページは、移動または削除された可能性があります。
        トップページより、目的の情報をお探しください。
      </p>
      <Link
        to="/"
        className="mt-10 inline-flex items-center gap-3 whitespace-nowrap border border-foreground-950 px-9 py-3.5 font-body text-[12px] tracking-[0.22em] text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
      >
        トップページへ戻る
        <i className="ri-arrow-right-line" />
      </Link>
    </div>
  );
}